export const EMPLOYEES_LIST_LOAD_SUCCESS = 'EMPLOYEES_LIST_LOAD_SUCCESS';
export const EMPLOYEES_LIST_LOAD_ERROR = 'EMPLOYEES_LIST_LOAD_ERROR';
export const EMPLOYEES_SET_SORT = 'EMPLOYEES_SET_SORT';
export const EMPLOYEES_SET_EMPLOYEE = 'EMPLOYEES_SET_EMPLOYEE';
export const EMPLOYEES_CLEAR_EMPLOYEE_DATA =
  'EMPLOYEES_CLEAR_EMPLOYEE_DATA';
